
import {
  defineComponent,
  onMounted,
  reactive,
  shallowReactive,
  ref,
  toRefs,
  onUnmounted
} from 'vue'
import { Popup, Form, Field, Picker, Toast, Button } from 'vant'
import { request } from '@/utils/request'
import SelectCity from '@/components/SelectCity.vue'
import { useRouter, useRoute, LocationQueryValue } from 'vue-router'

interface State {
  city_en: string
  city: string
  name: string | LocationQueryValue[]
  mobile: string | LocationQueryValue[] | null
  mianjival: string
  district: string
  houstypeval: string
  mianji: number
  housetype: number
  showPicker: boolean
}
const getData = async (city: string) => {
  try {
    const {
      data: {
        code,
        entry: { data }
      }
    } = await request.get(
      '/?site=api&ctl=purchase&act=get_js_district&city_k=' + city
    )
    if (code == '0') {
      return data
    } else {
      Toast.fail('获取数据失败')
    }
  } catch {
    Toast.fail('获取数据失败')
  }
}
const choosecity = () => {
  const visibleCityPopup = ref(false)
  const city = '北京'
  return {
    city,
    handleSelectCity() {
      visibleCityPopup.value = true
    },
    visibleCityPopup
  }
}
const getlist = async () => {
  try {
    const {
      data: {
        code,
        entry: { data }
      }
    } = await request.get('/?site=api&ctl=purchase&act=get_js_config')
    if (code == '0') {
      return data
    } else {
      Toast.fail('获取数据失败')
    }
  } catch {
    Toast.fail('获取数据失败')
  }
}
const Datafn = () => {
  const list = shallowReactive<{
    mianjilist: string[]
    houstypelist: string[]
    districtlist: string[]
  }>({
    mianjilist: [],
    houstypelist: [],
    districtlist: []
  })
  let columns = ref<Array<string>>([])
  const state = reactive<State>({
    city_en: '',
    city: '',
    name: '',
    mobile: '',
    mianjival: '',
    district: '',
    houstypeval: '',
    mianji: 0,
    housetype: 0,
    showPicker: false
  })

  const route = useRoute()
  onMounted(() => {
    if (route.query.name) {
      state.name = route.query.name
      state.mobile = route.query.mobile
    }
  })
  const citychange = async (value: { v: string; k: string }) => {
    if (state.city_en !== value.k) {
      const data = await getData(value.k)
      list.districtlist = []
      state.district = ''
      if (data) {
        list.districtlist = data
      }
    }
    state.city_en = value.k
    state.city = value.v
  }
  type ChooseType = keyof Omit<
    typeof state,
    'showPicker' | 'mianji' | 'housetype'
  >
  let choosetype = ref<ChooseType>('district')

  onMounted(async () => {
    const listdata = await getlist()
    if (listdata) {
      list.mianjilist = listdata.mianji
      list.houstypelist = listdata.housetype
    }
  })
  const router = useRouter()

  const onSubmit = async (values: Record<string, string>) => {
    values.city_en = state.city_en
    values.district = state.district
    values.housetype = String(state.housetype)
    values.mianji = String(state.mianji)
    try {
      const {
        data: { code }
      } = await request.get(
        '/?site=api&ctl=purchase&act=report&' +
          new URLSearchParams(values).toString()
      )
      if (code == '0') {
        if (route.path === '/detail') {
          router
            .replace({
              query: {
                city_en: values.city_en,
                district: values.district,
                mianji: values.mianji,
                housetype: values.housetype,
                name: values.name,
                mobile: values.mobile
              }
            })
            .then(() => {
              document.documentElement.scrollTop = 0
              window.location.reload()
            })
        } else {
          router.push({
            path: '/detail',
            query: {
              city_en: values.city_en,
              district: values.district,
              mianji: values.mianji,
              housetype: values.housetype,
              name: values.name,
              mobile: values.mobile
            }
          })
        }
      } else {
        Toast.fail('获取数据失败')
      }
    } catch {
      Toast.fail('获取数据失败')
    }
  }
  const handelselectColumns = (type: keyof typeof list) => {
    columns.value = list[type]
  }
  const handelselectState = (type: ChooseType) => {
    choosetype.value = type
    state.showPicker = true
  }

  const onConfirm = (value: { v: string; k: string | number }) => {
    state[choosetype.value] = value.v
    if (choosetype.value === 'mianjival') {
      state.mianji = value.k as number
    } else if (choosetype.value === 'houstypeval') {
      state.housetype = value.k as number
    }
    state.showPicker = false
  }
  const onFailed = (values: any) => {
    Toast.fail(values.errors[0].message)
  }
  return {
    onFailed,
    onSubmit,
    citychange,
    onConfirm,
    columns,
    ...toRefs(list),
    handelselectColumns,
    handelselectState,
    state
  }
}

export default defineComponent({
  name: 'DiglogForm',
  components: {
    Popup,
    Picker,
    Form,
    Field,
    SelectCity,
    Button
  },
  setup() {
    const { city, handleSelectCity, visibleCityPopup } = choosecity()
    const oriHeight = document.documentElement.clientHeight
    const dialog = reactive({
      height: '',
      butpadding: ''
    })

    const resize = () => {
      const curH = document.documentElement.clientHeight
      if (
        navigator.userAgent.indexOf('Android') > -1 ||
        navigator.userAgent.indexOf('Linux') > -1
      ) {
        if (curH !== oriHeight) {
          dialog.height = curH - 20 + 'px'
          dialog.butpadding = '20px'
        } else {
          dialog.height = ''
          dialog.butpadding = ''
        }
      }
    }
    onMounted(() => {
      window.addEventListener('resize', resize)
    })
    onUnmounted(() => {
      window.removeEventListener('resize', resize)
    })
    return {
      dialog,
      ...Datafn(),
      handleSelectCity,
      visibleCityPopup,
      city
    }
  }
})
